import * as React from 'react';

import { Route, Redirect } from 'react-router-dom';

import { AuthConsumer } from 'shared/contexts/AuthContext';

export default function ClosedProtectedRoute({ component: Component, ...rest }: any) {
    const settings = JSON.parse(localStorage.getItem('settings') as string);
    return (
        <Route
            {...rest}
            render={(props) => (
                <AuthConsumer>
                    {({ isAuth }) => {
                        return (isAuth || (settings && !settings.is_closed)) ? (
                            <Component {...props} />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: '/login',
                                    state: { from: rest.location },
                                }}
                            />
                        );
                    }
                    }
                </AuthConsumer>
            )}
        />
    );
}
